import { tv } from 'tailwind-variants';

export const styles = tv({
  base: `
    rounded-md
    bg-gray-100
    p-6
  `,
});
